import React, { Component } from 'react';
import { Link } from 'react-router';
import { GridList, GridTile } from 'material-ui/GridList';
import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppStore from '../../stores/app-store.js'
import { proximoJogadorActions } from '../../actions/app-actions.js'
import { statusCartas } from '../../actions/app-actions.js'
import './Jogador.css';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

const styles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
    },
    gridList: {
        height: 400,
        overflowY: 'auto',
    },
};


class Jogador extends Component {
    constructor(props) {
        super(props);
        this.trataTile = this.trataTile.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            estadocartas: AppStore.getCartas(),
            jogadorAtual: AppStore.getJogadorAtual(),
            legendas: AppStore.legendas,
        };
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        AppStore.addChangeJogAtualListener(this.onChange);
        proximoJogadorActions.proximo();
        this.setState({ estadocartas: AppStore.getCartas() });
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    trataTile(carta) {
        let copia = this.state.estadocartas.slice(0);
        if (copia[carta.key].jaescolhida === false) {
            copia[carta.key].frente = !carta.frente;
            copia[carta.key].selecionada = true;
            this.setState({ estadocartas: copia });
        }
    }



    componentWillUnmount() {
        AppStore.removeChangeJogAtualListener(this.onChange);
        statusCartas.atualiza(this.state.estadocartas);
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }

    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }


    onChange() {
        this.setState({
            jogadorAtual: AppStore.getJogadorAtual(),
        });
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="Jogador">
                    <h1>{this.state.legendas.jogador} {this.state.jogadorAtual}</h1>
                    <h2>{this.state.legendas.escolhaTres}</h2>
                    <GridList cols={2} padding={15} style={styles.gridList} cellHeight='auto'>
                        {
                            this.state.estadocartas
                                .filter(
                                (carta) => { return carta.jogador === this.state.jogadorAtual; }
                                )
                                .map(
                                (carta) => (
                                    <GridTile onClick={() => this.trataTile(carta)} key={carta.key} title={carta.frente ? carta.titulofrente : carta.tituloverso} titlePosition="top">
                                        <img alt="imagem" src={carta.frente ? carta.imgfrente : carta.imgverso} />
                                    </GridTile>
                                )
                                )
                        }
                    </GridList>
                    <div style={{ textAlign: 'right' }}>
                        <Link to="/cartax" style={{ fontFamily: 'OpenSans', fontSize: '36px', padding: '10px', color: 'white' }}>{this.state.legendas.avancar}</Link>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default Jogador;



// WEBPACK FOOTER //
// ./src/componentes/jogador/Jogador.js